import React, { useContext } from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../App';
import { isCCPage, useCC } from '../../contexts/CCContext';
import CCDashboard from './CCDashboard';
import './cc.css';
import { useYield } from './YieldContext';
import YieldPanel from './YieldPanel';

export default function CCPanel() {
  const { t } = useTranslation('translation');
  const cc = useCC();
  const yieldView = useYield();
  const isYield = yieldView?.view === 'yield';
  const { setGlobalCCViewEnabled } = useContext(GlobalContext);
  const { pathname } = useLocation(); const navigate = useNavigate();
  const close = () => {
    setGlobalCCViewEnabled(false);
    if (isCCPage(pathname)) navigate('/home');
  };
  return <section className="ci-panel" aria-label={t('general.crop_intelligence')} aria-busy={isYield ? yieldView.summary.status === 'loading' : !!cc.loading}>
    {!isYield && cc.loading && <div className="ci-loading-bar" role="progressbar" aria-label={t('ci.loadingPublication')}><span /></div>}
    <header className="ci-panel-heading"><h2>{t('general.crop_intelligence')}</h2>
      <Button type="text" icon={<CloseOutlined />} aria-label={t('ci.close')} onClick={close} />
    </header>
    {yieldView && <nav className="yield-tabs" aria-label={t('yield.views')}>
      <Button type={!isYield ? 'primary' : 'default'} aria-pressed={!isYield} onClick={() => yieldView.setView('crops')}>{t('yield.crops')}</Button>
      <Button type={isYield ? 'primary' : 'default'} aria-pressed={isYield} onClick={() => yieldView.setView('yield')}>{t('yield.title')}</Button>
    </nav>}
    {isYield ? <YieldPanel /> : <CCDashboard />}
  </section>;
}
